import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { type FC, useCallback, useEffect, useState } from "react";
import type { Help } from "../../../../@types/services/Help";
import { FullScreenLoading } from "../../../../components/molecules/FullScreenLoading";
import { ListHelps } from "../../../../components/molecules/ListHelps";
import { fetchHelps } from "../../../../services/helps";

const _Helps: FC<{ typeHelp: string }> = ({ typeHelp }) => {
  const [helps, setHelps] = useState<Help[]>([]);
  const [helpsPerPage] = useState(25);

  const handleFetchHelps = useCallback(
    async (page: number, helpsPerPageParam: number) => {
      await fetchHelps(1, typeHelp).then(({ results }) => {
        setHelps(results.slice(page, helpsPerPageParam));
      });
    },
    [typeHelp],
  );

  useEffect(() => {
    handleFetchHelps(0, helpsPerPage);
  }, [handleFetchHelps, helpsPerPage]);

  return (
    <Box
      component="main"
      sx={{
        display: "grid",
        flexGrow: 1,
        gap: 1,
        gridTemplateAreas: `
            "main"
          `,
        gridTemplateColumns: "repeat(1, 1fr)",
        gridTemplateRows: "auto",
        height: "100%",
        justifyContent: "center",
        p: 1,
        width: "100%",
      }}
    >
      <Box sx={{ gridArea: "main" }}>
        <ListHelps helps={helps} type_help={typeHelp} />
      </Box>
    </Box>
  );
};

const RouteComponent: FC = () => {
  useEffect(() => {
    window.location.reload();
  }, []);

  return <FullScreenLoading />;
};

export const Route = createFileRoute("/_private/vbuyer/helps/")({
  component: RouteComponent,
});
